import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import api from '../lib/api';
import { EyeOpen, EyeOff } from '../components/icons';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return toast.error('Enter email and password');
    try {
      setLoading(true);
      const { data } = await api.post('/auth/login', { email, password });
      if (data?.token) {
        localStorage.setItem('auth_token', data.token);
        if (data.refreshToken) localStorage.setItem('refresh_token', data.refreshToken);
        toast.success('Welcome back!');
        navigate('/account');
      } else {
        toast.error('Login failed');
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-custom pt-28 sm:pt-32 pb-16">
      <div className="max-w-md mx-auto card">
        <h1 className="text-2xl font-semibold mb-6">Sign in</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input
              type="email"
              className="input-field"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                className="input-field pr-12"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                className="absolute inset-y-0 right-2 my-auto h-9 w-9 rounded-xl text-gray-600 hover:text-[#0D56A6] hover:bg-gray-100 transition-colors flex items-center justify-center"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOff size={18} /> : <EyeOpen size={18} />}
              </button>
            </div>
          </div>
          <button type="submit" className="w-full bg-[#0D56A6] hover:bg-[#0A4A8F] text-white font-semibold py-3 px-4 rounded-2xl transition-colors" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <p className="text-sm text-gray-600 mt-4">
          Don't have an account? <Link to="/register" className="text-[#0D56A6] hover:underline">Register</Link>
        </p>
      </div>
    </div>
  );
}
